// Mirrors BILLING_CHARGE_TYPES / BILLING_CHARGE_STATUSES in the API's
// entities/BillingChargePlaceholder.ts.
export const BILLING_CHARGE_TYPES = [
  "FREIGHT",
  "WEIGHT_DISPUTE",
  "COD_FEE",
  "RETURN_FEE",
  "INSURANCE",
  "NEXT_DAY_REMITTANCE",
  "ADDITIONAL_SERVICE",
  "REFUND_WEIGHT_DISPUTE",
  "REFUND_COD_FEE",
  "REFUND_NEXT_DAY_REMITTANCE",
  "REFUND_RETURN_FEE",
  "REFUND_CANCELLED_BY_USER",
  "CHARGE_CANCELLED_BY_USER_REFUND_REVERSAL",
  "MANUAL_ADJUSTMENT",
];

export const BILLING_CHARGE_STATUSES = ["UNBILLED", "RESERVED", "BILLED", "VOID"];

export const BILLING_CHARGE_STATUS_COLORS = {
  UNBILLED: "orange",
  RESERVED: "blue",
  BILLED: "green",
  VOID: "default",
};
